type JsonLd = Record<string, unknown>;

type SeoProps = {
  title: string;
  description: string;
  keywords?: string;
  canonical: string;
  ogType?: string;
  ogImage?: string;
  jsonLd?: JsonLd | JsonLd[];
};

const SITE_NAME = "爆料现场";
const DEFAULT_OG_IMAGE =
  "https://readdy.ai/api/search-image?query=abstract%20stylized%20illustration%20of%20a%20glowing%20live%20streaming%20broadcast%20stage%20with%20dramatic%20spotlight%20beams%20and%20floating%20rectangular%20screens%2C%20warm%20cream%20background%20with%20deep%20vermillion%20orange%20and%20golden%20amber%20accents%2C%20grainy%20editorial%20poster%20texture%2C%20cinematic%20high%20contrast%20lighting%2C%20modern%20magazine%20cover%20aesthetic%2C%20dynamic%20diagonal%20composition%2C%20no%20text&width=1600&height=1000&seq=bolo-hero-01&orientation=landscape";

export default function Seo({
  title,
  description,
  keywords,
  canonical,
  ogType = "website",
  ogImage = DEFAULT_OG_IMAGE,
  jsonLd,
}: SeoProps) {
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content="index,follow" />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      <meta name="last-modified" content="2026-09-10" />
      {jsonLd && (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      )}
    </>
  );
}